import {
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAIL,


  UPDATE_SETTINGS,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_FAIL,

} from "./actionTypes"


export const getSettings = (
  page,
  limit,
  searchText,
  sortByDate
) => {

  return {
    type: GET_SETTINGS,
    payload: { page, limit, searchText, sortByDate },
  }
}
export const getSettingsSuccess = settings => ({
  type: GET_SETTINGS_SUCCESS,
  payload: settings,
})

export const getSettingsFail = error => ({
  type: GET_SETTINGS_FAIL,
  payload: error,
})




export const updateSettings = (
  settings,
  settingsId,
  handleCloseModal,
) => {
  return {
    type: UPDATE_SETTINGS,
    payload: { settings, settingsId, handleCloseModal },
  }
}


export const updateSettingsSuccess = settings => ({
  type: UPDATE_SETTINGS_SUCCESS,
  payload: settings,
})

export const updateSettingsFail = error => ({
  type: UPDATE_SETTINGS_FAIL,
  payload: error,
})
